/**
 * GearRentalIcons.jsx
 * Created by Destin Frasier on 12/19/19.
 */

import GearRentalIconsSingleton from './gearRentalIconSingleton';
import BaseIcon from '../BaseIcon';

class GearRentalIcon extends BaseIcon {
    constructor(props) {
        super(props);

        this.iconSingleton = GearRentalIconsSingleton;
    }
}

export class GearRentalIconRentStep extends GearRentalIcon {}
GearRentalIconRentStep.defaultProps = {
    iconName: 'rec-icon-gear-rental-rent-step',
    iconClass: 'rec-icon-gear-rental-rent-step',
    alt: 'Rent Gear',
};

export class GearRentalIconEnjoyStep extends GearRentalIcon {}
GearRentalIconEnjoyStep.defaultProps = {
    iconName: 'rec-icon-gear-rental-enjoy-step',
    iconClass: 'rec-icon-gear-rental-enjoy-step',
    alt: 'Enjoy the Gear',
};

export class GearRentalIconReturnStep extends GearRentalIcon {}
GearRentalIconReturnStep.defaultProps = {
    iconName: 'rec-icon-gear-rental-return-step',
    iconClass: 'rec-icon-gear-rental-return-step',
    alt: 'Return Gear',
};

export class GearRentalIconReceiveStep extends GearRentalIcon {}
GearRentalIconReceiveStep.defaultProps = {
    iconName: 'rec-icon-gear-rental-receive-step',
    iconClass: 'rec-icon-gear-rental-receive-step',
    alt: 'Receive Gear',
};

export class GearRentalIconCampingSet extends GearRentalIcon {}
GearRentalIconCampingSet.defaultProps = {
    iconName: 'rec-icon-gear-rental-camping-set',
    iconClass: 'rec-icon-gear-rental-camping-set',
    alt: 'Camping Sets',
};

export class GearRentalIconCampingTent extends GearRentalIcon {}
GearRentalIconCampingTent.defaultProps = {
    iconName: 'rec-icon-gear-rental-camping-tent',
    iconClass: 'rec-icon-gear-rental-camping-tent',
    alt: 'Camping Tents & Shelters',
};

export class GearRentalIconCampingKitchen extends GearRentalIcon {}
GearRentalIconCampingKitchen.defaultProps = {
    iconName: 'rec-icon-gear-rental-camping-kitchen',
    iconClass: 'rec-icon-gear-rental-camping-kitchen',
    alt: 'Kitchen Gear',
};

export class GearRentalIconBackpackingSet extends GearRentalIcon {}
GearRentalIconBackpackingSet.defaultProps = {
    iconName: 'rec-icon-gear-rental-backpacking-set',
    iconClass: 'rec-icon-gear-rental-backpacking-set',
    alt: 'Backpacking Set',
};

export class GearRentalIconBackpackingPack extends GearRentalIcon {}
GearRentalIconBackpackingPack.defaultProps = {
    iconName: 'rec-icon-gear-rental-backpacking-pack',
    iconClass: 'rec-icon-gear-rental-backpacking-pack',
    alt: 'Backpacking Packs',
};

export class GearRentalIconBackpackingTent extends GearRentalIcon {}
GearRentalIconBackpackingTent.defaultProps = {
    iconName: 'rec-icon-gear-rental-backpacking-tent',
    iconClass: 'rec-icon-gear-rental-backpacking-tent',
    alt: 'Backpacking Tents & Shelters',
};

export class GearRentalIconPromoTent extends GearRentalIcon {}
GearRentalIconPromoTent.defaultProps = {
    iconName: 'rec-icon-gear-rental-promo-tent',
    iconClass: 'rec-icon-gear-rental-promo-tent',
    alt: 'Gear Rental',
};

export class RentalTent extends GearRentalIcon {}
RentalTent.defaultProps = {
    iconName: 'rec-icon-rental-tent',
    iconClass: 'rec-icon-rental-tent',
    alt: 'Gear Rental',
};

export class RentalRv extends GearRentalIcon {}
RentalRv.defaultProps = {
    iconName: 'rec-icon-rental-rv',
    iconClass: 'rec-icon-rental-rv',
    alt: 'RV Rental',
};
